<template>
	<div>
		<h4>Content</h4>
		<quill-editor v-model="content" class="mt-2"></quill-editor> <!--:options="{theme: 'bubble'}" -->
		<vs-button :disabled="loading" @click="saveContent()" color="success" class="mt-2">Opslaan</vs-button>
	</div>
</template>
<script>
	import api from '../../api';
	export default {
		name: 'AboutUs',
		components: {},
		props: {},
		data () {
			return {
				content: "",
				page: null,
				loading: false
			}
		},
		watch: {
			'$route.params.id': function (id) {
				this.page = id;
				this.getSetting();
			}
		},
		computed: {

		},
		mounted () {
			this.page = this.$route.params.id;
			this.getSetting();
		},
		methods: {
			getSetting(){
				this.loading = true;
				api.post("admin/settings", {keys: [this.page]}).then(response=>{
					this.content = response.data[0].value;
					this.loading = false;
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				})
			},
			saveContent(){
				this.loading = true;
				const settings = {};
				settings[this.page] = this.content;
				api.put("admin/settings", {settings}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de over ons pagina is gelukt',
						color: 'success'
					});
					this.loading = false;
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				})
			}
		}
	}

</script>
